<template>
    <!-- TODO css -->
    <modal @close="modals.apiKeyModal = false" :width="550">
        <div v-if="screen === 'form'">
            <h3>Create New API Key</h3>
            <div class="large-form">
                <div class="form-line">
                    <div id="form-field-name" class="form-field" style="width: 100%">
                        <label for="form-input-name">Key Name *</label>
                        <input v-model="key.name" type="text" id="form-input-name" required="required" />
                    </div>
                </div>
                <div class="modal-errors">
                    <p v-for="e in errors" class="form-field error-text">{{ e[0] }}</p>
                </div>
            </div>
            <div class="form-actions">
              <span class="ws-button ws-button-secondary" data-action="cancel" @click="modals.apiKeyModal = false">Cancel</span>
              <span class="ws-button ws-button-main" data-action="start-campaign-confirm" @click="createApiKey">Create API Key</span>
            </div>
        </div>
        
        
        <!-- Loading -->
        <div v-else-if="screen === 'processing'">
            <div class="ws-form-processing"><div class="value-loader"></div><p>We're generating your new API key...<br>Please give us a moment...</p></div>
        </div>
        
        <!-- Loading -->
        <div v-else-if="screen === 'created'">
            <h3>Your New API Key</h3>
            <div class="large-form">
                  <div class="form-line">
                      <p>Your new API key has been generated. You can copy it below. Please save your key securely - <b>you will not be able to view it again</b>.</p>
                      <p class="api-key">{{ key.real_key }}</p>
                      <div style="margin: 20px auto"><span class="ws-button ws-button-main" @click="copyToClipboard(key.real_key)">COPY API KEY</span></div>
                  </div>
            </div>
            <div class="form-actions">
                <span class="ws-button ws-button-secondary" data-action="cancel" @click="modals.apiKeyModal = false">CLOSE</span>
            </div>
        </div>
        
    </modal>
</template>

<script>
import Modal from "@/components/modals/Modal";

export default {
    name: "UserSettingsModal",
    components: {Modal},
    props: {
        teamMemberId: Number,
    },
    data() {
        return {
            key: {name: '', full_key: ''},
            errors: {},
            screen: 'form',
        }
    },
    methods: {
        async createApiKey() {
            if (!this.demoCheck()) return;
            
            let fieldsToValidate = [
                { name: 'Name', value: this.key.name, rules: ['required'] },
            ];
            this.errors = this.validateFields(fieldsToValidate);
            if (Object.keys(this.errors).length) return;   
            this.screen = 'processing';
            this.key = await this.dispatchWaitAndNotify('createTeamApiKey', {'name': this.key.name}, false, true);
            this.screen = 'created';
            this.dispatchWaitAndNotify('fetchTeamApiKeys', null, false, true);
        },
        copyToClipboard(text) {
            const el = document.createElement('textarea');
            el.value = text;
            el.setAttribute('readonly', '');
            el.style.position = 'absolute';
            el.style.left = '-9999px';
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
            this.notifyStatus(200, 'API Key Copied', 'The API key has been copied to your clipboard.');
    	},
    },
    async mounted() {

    },
    computed: {
        team() {
            return this.$store.state.team.detail;
        },
        modals() {
            return this.$store.state.modals;
        },
    }
}
</script>
<style scoped>
.api-key {
    font-family: monospace;
    background: #eee;
    padding: 5px 8px;
    border-radius: 5px;
    font-size: 12px;
}
</style>